module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-chef-kitchen-7d49ceea.jpg";